module.exports = __webpack_public_path__ + "img/mobile_btn8.e04b0e45.png";